// extracted by mini-css-extract-plugin
module.exports = {"report":"PowerBiViewer_report__1Obap"};